import React, { useState } from "react";
import PropTypes from "prop-types";
import { getState } from "core-web/state";
import addToBasket from "core-web/state/models/Basket/dispatches/addToBasket";
import hidePopup from "core-web/state/models/Popups/dispatches/hidePopup";
import showPopup from "core-web/state/models/Popups/dispatches/showPopup";
import { isEmpty } from "core-web/utils/object";
import RelationQuickShopButton from "theme/components/productPage/RelationQuickShopButton";

const RelationQuickShop = ({ isVariant, product, handleMenu, selectedParametrics, declaredVariant, quantity }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isAdded, setIsAdded] = useState(false);

    const isVariantSelected = !isEmpty(declaredVariant || {});

    const handleAddToBasket = async () => {
        if (isLoading) {
            return;
        }

        setIsLoading(true);

        const currentProduct = isVariant ? declaredVariant : product;

        try {
            await addToBasket(
                currentProduct.partNo || currentProduct.part_no,
                quantity,
                currentProduct.priceListId || currentProduct.price_list_id,
            );

            setIsAdded(true);
            setIsLoading(false);
            const basketIsOpen = getState("overlay").current === "basket_overlay";

            if (!basketIsOpen) {
                const pageType = getState("page").type;
                if (pageType !== "storm_checkout") {
                    showPopup("addedToBasketPopup", {
                        [currentProduct.id]: {
                            image: currentProduct.format?.image || currentProduct.image,
                            manufacturerName: currentProduct.manufacturer?.name || currentProduct.manufacturer_name,
                            name: currentProduct.name,
                            productId: currentProduct.id,
                        },
                    });

                    setTimeout(() => {
                        hidePopup("addedToBasketPopup", currentProduct.id);
                    }, 5500);
                }
            }

            setTimeout(() => {
                setIsAdded(false);
                setIsLoading(false);
            }, 4000);
        } catch (e) {
            console.error(e);
            setIsAdded(false);
            setIsLoading(false);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isVariant) {
            handleMenu();
        }

        handleAddToBasket();
    };

    return (
        <RelationQuickShopButton
            isAdded={isAdded}
            isLoading={isLoading}
            isVariant={isVariant}
            isVariantSelected={isVariantSelected}
            priceExVat={declaredVariant?.priceExVat || declaredVariant?.price}
            vatRate={declaredVariant?.vatRate || declaredVariant?.vat_rate}
            selectedParametrics={selectedParametrics}
            handleClick={handleClick}
            product={product}
            relationsVariant={declaredVariant}
            quantity={quantity}
        />
    );
};

RelationQuickShop.propTypes = {
    declaredVariant: PropTypes.object,
    handleMenu: PropTypes.func,
    isVariant: PropTypes.bool.isRequired,
    product: PropTypes.object,
    quantity: PropTypes.number,
    selectedParametrics: PropTypes.array,
};

RelationQuickShop.defaultProps = {
    declaredVariant: {},
    handleMenu: () => {},
    product: {},
    quantity: 1,
    selectedParametrics: [],
};

export default RelationQuickShop;
